import React, { Fragment, useState } from 'react';
import LoginBannerImage from '../../../icons/user-screen-banner.png';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { getUserEmail, getActivePackge } from '../selectors';
import { Redirect } from 'react-router-dom';

import ImageLogo from '../../../icons/litterati.svg';

import LoaderGif from '../../../icons/LoaderGif.gif';

import FormInput from '../../../common/FormInput';
import { TextField } from '@material-ui/core';
import './styles.scss';
import { getPartnerSignupError, getPartnerSignupStatus } from '../selectors';
import { uploadImage } from '../../../helpers/uploadImageToAWS';
import { partnerSignupRequested } from '../actions';
import { ROUTE_DASHBOARD } from '../../../navigation/constants';
import { Modal } from 'react-bootstrap';

function PartnerSignup({
    onFormSubmit,
    error,
    isPartnerSignedup,
    partnerEmail,
    partnerTypeKey,
}) {
    if (isPartnerSignedup) {
        return (
            <Redirect
                to={{
                    pathname: ROUTE_DASHBOARD,
                }}
            />
        );
    }
    const defaultPartnerImage =
        'https://litterati-avatars-prod.s3-us-west-2.amazonaws.com/users/user-default/profile-picture-aqua.png';
    const [partnerOrganization, setPartnerOrganization] = useState(null);
    const [partnerBio, setPartnerBio] = useState(null);
    const [partnerImage, setPartnerImage] = useState(defaultPartnerImage);
    const [partnerBanner, setPartnerBanner] = useState(null);
    const [uploadingImage, setUploadingImage] = useState(false);
    const [uploadingBanner, setUploadingBanner] = useState(false);
    const [uploadingBannerSuccess, setUploadingBannerSuccess] = useState(false);
    const [disclaimerModal, setDisclaimerModal] = useState(true);

    const disclaimerModalClose = () => {
        setDisclaimerModal(false);
    };

    function clickUploadBanner() {
        document.getElementById('upload_banner').click();
    }

    function clickUploadImage() {
        document.getElementById('upload_image_input').click();
    }
    async function uploadToS3(type, e) {
        type == 'PartnerProfile'
            ? setUploadingImage(true)
            : setUploadingBanner(true);
        let response = await uploadImage(e);
        setUploadingImage(false);
        setUploadingBanner(false);
        if (type == 'PartnerProfile') setPartnerImage(response);
        if (type == 'PartnerBanner') {
            setUploadingBannerSuccess(true);
            setPartnerBanner(response);
        }
    }

    const disclaimer = (
        <>
            <div className="signup-disclaimer-modal">
                <Modal
                    show={disclaimerModal}
                    onHide={disclaimerModalClose}
                    dialogClassName={'signup-disclaimer-modal'}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    centered={true}
                    animation={true}
                >
                    <div className="row">
                        <div className="col-12">
                            <div className="row title">Note</div>
                            <div className="row mt-2">
                                You must fill out this page & click ‘Save’ to
                                create your account.
                            </div>
                            <div className="row">
                                <button
                                    className={
                                        'btn btn-block close-modal-button mt-4'
                                    }
                                    type={'button'}
                                    onClick={() => disclaimerModalClose()}
                                >
                                    Got It
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </>
    );
    const newDate = new Date();

    return (
        <Fragment>
            {disclaimer}
            <section className="login-block partner-signup-block">
                <div className="container-fluid">
                    <div
                        className="row partner-signup-banner-image"
                        style={{
                            background: `url(${LoginBannerImage}) no-repeat center center`,
                            backgroundSize: '100%',
                        }}
                    >
                        <div className="col-md-4 login-sec formbox partner-signup-form">
                            <div className="row">
                                <div className="col">
                                    <div className="row justify-content-center m-4">
                                        <img src={ImageLogo} />
                                    </div>
                                    {error && !isPartnerSignedup ? error : null}
                                    <div className="row">
                                        <div className="col create-partner-heading">
                                            Create Your Profile
                                        </div>
                                    </div>

                                    <div className="row justify-content-center mt-4">
                                        <div
                                            className="col-auto"
                                            style={{
                                                backgroundImage: `url(${partnerImage})`,
                                                backgroundSize: 'cover',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'center',
                                                height: '6.5rem',
                                                width: '6.5rem',
                                                borderRadius: '100%',
                                            }}
                                        >
                                            <button
                                                className="upload-image"
                                                onClick={() =>
                                                    clickUploadImage()
                                                }
                                            >
                                                {uploadingImage ? (
                                                    <>
                                                        <img
                                                            src={LoaderGif}
                                                            alt=""
                                                            className="Loader"
                                                        ></img>
                                                        <span className="icon-latest-camera"></span>
                                                    </>
                                                ) : (
                                                    <span className="icon-latest-camera"></span>
                                                )}
                                            </button>
                                            <input
                                                type="file"
                                                onChange={(e) =>
                                                    uploadToS3(
                                                        'PartnerProfile',
                                                        e,
                                                    )
                                                }
                                                id={'upload_image_input'}
                                                hidden={true}
                                            ></input>
                                        </div>
                                    </div>

                                    <div className="row mt-3 justify-content-center">
                                        <div className="col-auto pl-2 pr-2 text-center package-text">
                                            {partnerTypeKey}
                                        </div>
                                    </div>
                                    <form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            onFormSubmit({
                                                name: partnerOrganization,
                                                email: partnerEmail,
                                                description: partnerBio,
                                                profilePicture: partnerImage,
                                                banner: partnerBanner
                                                    ? partnerBanner
                                                    : null,
                                            });
                                        }}
                                    >
                                        <div className="row mt-4">
                                            <div className="col-12">
                                                <FormInput
                                                    title={'Organization Name'}
                                                    bootstrapIcon="icon-latest-organization"
                                                >
                                                    <TextField
                                                        value={
                                                            partnerOrganization
                                                        }
                                                        type={'text'}
                                                        required={true}
                                                        placeholder={`Add Your Organization's Name`}
                                                        onChange={(event) =>
                                                            setPartnerOrganization(
                                                                event.target
                                                                    .value,
                                                            )
                                                        }
                                                    />
                                                </FormInput>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12 bio-textarea">
                                                <FormInput
                                                    title={'Bio'}
                                                    bootstrapIcon="icon-latest-pencil"
                                                >
                                                    <TextField
                                                        value={partnerBio}
                                                        type={'text'}
                                                        placeholder={
                                                            'Write a small bio about your organization'
                                                        }
                                                        onChange={(event) =>
                                                            setPartnerBio(
                                                                event.target
                                                                    .value,
                                                            )
                                                        }
                                                        multiline
                                                        rows={4}
                                                    />
                                                </FormInput>
                                            </div>
                                        </div>
                                        <button
                                            id={'form_submit_botton'}
                                            hidden={true}
                                        ></button>
                                    </form>

                                    <div className="row mt-2">
                                        <div className="col create-partner-heading">
                                            <button
                                                className={
                                                    'btn btn-block btn-upload upload-banner'
                                                }
                                                onClick={() =>
                                                    clickUploadBanner()
                                                }
                                            >
                                                <span className="icon-latest-gallery upload-banner-icon"></span>
                                                {uploadingBanner ? (
                                                    <img
                                                        src={LoaderGif}
                                                        width={'25px'}
                                                        height={'25px'}
                                                    />
                                                ) : uploadingBannerSuccess ? (
                                                    'Upload Successful'
                                                ) : (
                                                    'Upload Banner Image'
                                                )}
                                            </button>
                                            <input
                                                type="file"
                                                id={'upload_banner'}
                                                onChange={(e) =>
                                                    uploadToS3(
                                                        'PartnerBanner',
                                                        e,
                                                    )
                                                }
                                                hidden={true}
                                            ></input>
                                        </div>
                                    </div>

                                    <div className="row mt-5 mb-4">
                                        <div className="col create-partner-heading">
                                            <button
                                                className={
                                                    'btn btn-block btn-upload create-partner-button'
                                                }
                                                type={'button'}
                                                onClick={() =>
                                                    document
                                                        .getElementById(
                                                            'form_submit_botton',
                                                        )
                                                        .click()
                                                }
                                            >
                                                {'Save'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <footer className="row justify-content-center mr-0">
                <div className="col-auto partner-copyrights">
                    {' '}
                    © Copyright {newDate.getFullYear()} Litterati
                </div>
            </footer>
        </Fragment>
    );
}

PartnerSignup.propTypes = {
    onFormSubmit: PropTypes.func,
    error: PropTypes.string,
    isPartnerSignedup: PropTypes.bool,
    partnerEmail: PropTypes.string,
    partnerTypeKey: PropTypes.string,
};

PartnerSignup.defaultProps = {
    partnerDetails: null,
};

const mapStateToProps = (state) => {
    return {
        error: getPartnerSignupError(state),
        isPartnerSignedup: getPartnerSignupStatus(state),
        partnerEmail: getUserEmail(state),
        partnerTypeKey: getActivePackge(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onFormSubmit: (partnerDetails) =>
            dispatch(partnerSignupRequested(partnerDetails)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerSignup);
